// Scratch surface for previewing components in isolation. Intentionally empty
// between tasks — drop a preview in here while iterating on a screen, then clear
// it back to this shell when the work lands.

import React from 'react';

const DevPage: React.FC = () => (
  <div className="h-screen w-screen bg-neutral-950" />
);

export default DevPage;
